export class ConnectivityError extends Error {}
export class InternetError     extends ConnectivityError {}
export class ServerError       extends ConnectivityError {}

export class HttpError extends Error {
  constructor(message) {
    super(message);
    this.name = "NetworkError";
  }
}

export class NetworkError extends Error {
  constructor(response, body) {
    super(`HTTP ${response.status} ${response.statusText}`);
    this.name = "HttpError";
    this.status = response.status;
    this.body = body;
  }
}

export class TimeoutError extends Error {
  constructor(timeout) {
    super(`Request timed out after ${timeout}ms`);
    this.name = "TimeoutError";
  }
}

export async function fetchWithTimeout(url, options = {}, timeout = 5000) {
  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), timeout);
  try {
    return await fetch(url, { ...options, signal: controller.signal });
  } finally {
    clearTimeout(id);
  }
}

async function headWithTimeout(
  url, timeout = 2000
) {
  const ctrl = new AbortController();
  const id = setTimeout(() => ctrl.abort(), timeout);
  try {
    return await fetch(url, { method: "HEAD", cache: "no-store", signal: ctrl.signal });
  } finally {
    clearTimeout(id);
  }
}

export async function corsPing(
  url = "https://api.ipify.org?format=json",
  timeout = 2000
) {
  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), timeout);

  try {
    const res = await fetch(url, { signal: controller.signal });

    if (!res.ok) {
      throw new InternetError(`Internet source failed (${res.status})`);
    }
  } catch (err) {
    throw new InternetError("No network connectivity");
  } finally {
    clearTimeout(id);
  }
}

export async function checkInternet() {
  try {
    await corsPing();
  } catch (err) {
	// console.log(err);
    throw new InternetError("Check your internet connection");
  }
}

export async function checkServer(baseUrl) {
  try {
    const res = await headWithTimeout(`${baseUrl}`, 20000);
	// console.log(res);
    if (!res.ok) {
      throw new ServerError(`Health check failed: ${res.status}`);
    }
  } catch (err) {
    // console.log(err);
    if (err instanceof InternetError) throw err;
    throw new ServerError("Request Timed Out.");
  }
}